import { navInitialState } from './_state.inits';
import { NavState } from './_state.interfaces';
import { NavActions, NavActionTypes } from './nav.actions';

export function navReducer(state = navInitialState, action: NavActions): NavState {
  switch (action.type) {
    case NavActionTypes.ShowMenu: {
        return { ...state, showMenu: true };
    }
    case NavActionTypes.HideMenu: {
        return { ...state, showMenu: false };
    }
    case NavActionTypes.OpenSideNav: {
        return { ...state, openSideNav: true };
    }
    case NavActionTypes.CloseSideNav: {
        return { ...state, openSideNav: false };
    }
    default:
      return state;
  }
}
